var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAnaylses(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 97,
    viewBox: "0 0 97 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon 1",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M96.9999 0H90.5332V77.6H96.9999V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M77.6 90.5333H0V97H77.6V90.5333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.4003 51.7333H12.9336V84.0667H19.4003V51.7333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M38.8007 32.3333H32.334V84.0667H38.8007V32.3333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M58.1991 12.9333H51.7324V38.8H58.1991V12.9333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M77.5995 0H71.1328V38.8H77.5995V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M64.6656 84.0667C60.8287 84.0667 57.0779 82.9289 53.8876 80.7972C50.6973 78.6655 48.2107 75.6356 46.7424 72.0907C45.274 68.5458 44.8898 64.6451 45.6384 60.8819C46.387 57.1187 48.2346 53.6619 50.9478 50.9488C53.6609 48.2356 57.1177 46.388 60.8809 45.6394C64.6441 44.8909 68.5448 45.2751 72.0897 46.7434C75.6346 48.2117 78.6644 50.6983 80.7961 53.8886C82.9278 57.0789 84.0656 60.8297 84.0656 64.6667C84.0656 69.8119 82.0217 74.7463 78.3835 78.3845C74.7453 82.0227 69.8108 84.0667 64.6656 84.0667ZM64.6656 51.7333C62.1077 51.7333 59.6071 52.4919 57.4803 53.913C55.3534 55.3341 53.6957 57.354 52.7168 59.7173C51.7379 62.0805 51.4818 64.681 51.9808 67.1898C52.4798 69.6986 53.7116 72.0031 55.5204 73.8119C57.3291 75.6207 59.6336 76.8524 62.1425 77.3515C64.6513 77.8505 67.2517 77.5944 69.615 76.6155C71.9783 75.6366 73.9982 73.9789 75.4193 71.852C76.8404 69.7252 77.599 67.2246 77.599 64.6667C77.599 61.2365 76.2363 57.9469 73.8109 55.5214C71.3854 53.0959 68.0958 51.7333 64.6656 51.7333Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M76.6332 72.0867L72.0605 76.6593L91.4485 96.0473L96.0211 91.4747L76.6332 72.0867Z",
    fill: "black"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnaylses);
export default __webpack_public_path__ + "static/media/anaylses.c57b4e766f699e3186c95779c33e705c.svg";
export { ForwardRef as ReactComponent };